import * as React from 'react';
export const IcTorchOff = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M17.41 12.41a2 2 0 00.44-2.18A2 2 0 0016 9h-2.76L17 12.79l.41-.38zm-.59-4.84l1.72-2.45a.999.999 0 00-.996-1.628A1 1 0 0016.9 4l-1.72 2.43a1.001 1.001 0 101.64 1.14zm3.89 11.72l-16-16a1.004 1.004 0 00-1.42 1.42l4.35 4.34a2 2 0 00-1 3.36L9 14.83V19a3 3 0 006 0v-2.59l4.29 4.3a1.001 1.001 0 001.639-.325 1 1 0 00-.22-1.095zM12 16a1 1 0 110-2 1 1 0 010 2zm0-9a1 1 0 001-1V3a1 1 0 10-2 0v3a1 1 0 001 1z'
      fill='currentColor'
    />
  </svg>
);
